import ScanForApp from './ScanForApp';

export default ScanForApp;
